import React, { useEffect } from 'react'
import "./Blog_inner.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Breadcrumb_comp from '../../common_components/breadcrumb-comp/Breadcrumb_comp';
import { useDispatch, useSelector } from 'react-redux';
import { getblogById } from '../../../features/blog/Slice';
import { useParams } from 'react-router-dom';
import { formatDate } from '../../../utils/common';
import parse from 'html-react-parser';
function Blog_inner() {
    const { id } = useParams();

    const blog = useSelector((state) => state.blog.blog);
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "BLOGS", link: "/blog", isActive: false },
        { label: blog?.name, link: "", isActive: true },
    ];

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getblogById(id));
    }, [dispatch, id]);



    return (
        <>
            <section className='Blog_inner'>
                <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                <div className="container">
                    <div className='Blog_inner_holder'>
                        <div className="blog-content">
                            <div className="float-image">
                                <img
                                    src={process.env.REACT_APP_IMG_URL  + blog?.image}
                                    alt="Blog_inner_img"
                                    className="Blog_inner_img"
                                />
                            </div>


                            <div className='text_holder'>
                                <h4 className="heading_text">{blog?.name}</h4>
                                <span className="date_text">{formatDate(blog?.updatedAt)}</span>
                            </div>
                            <div className='text_holder'>
                                <p>
                                    {blog?.subname}
                                </p>
                                <p>
                                    {parse(typeof blog?.description === "string" ? blog.description : "")}
                                </p>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </>
    )
}


export default Blog_inner
